import React, { useEffect, useMemo, useState } from "react";
import { Modal } from "react-bootstrap";
import {useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import { useCartPriceUIContext } from "../CartPriceUIContext";
import { deleteCartPricing, fetchCartDataPricing, fetchSingleCart } from "../../../actions/cart-pricing/cart";

export function CartPriceDeleteDialog({ show, onHide, id }) {
  
  // Cart UI Context
  const cartUIContext = useCartPriceUIContext();
  const cartUIProps = useMemo(() => {
    return {
      ids: id,
      queryParams: cartUIContext.queryParams,
      setQueryParams: cartUIContext.setQueryParams,
    };
  }, [cartUIContext, id]);

  // Products Redux state
  const dispatch = useDispatch();

  const { enqueueSnackbar } = useSnackbar();
  

  // if there weren't selected products we should close modal
  useEffect(() => {
    if (!cartUIProps.ids || cartUIProps.ids.length === 0) {
      onHide();
    } else {
      dispatch(fetchSingleCart(cartUIProps.ids));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, cartUIProps.ids]);

  const deleteCart = () => {
    // server request for deleting product by seleted ids
    enableLoading();
    dispatch(deleteCartPricing(id)).then(async (data) => {
      
      onHide();

      await dispatch(fetchCartDataPricing());

      await enqueueSnackbar('Cart pricing deleted successfully', {
        variant: "success",
        autoHideDuration: 4500,
      });

      disableLoading();
    });
  };

  const [loading, setLoading] = useState(false);

  const enableLoading = () => {
    setLoading(true);
  };

  const disableLoading = () => {
    setLoading(false);
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby='example-modal-sizes-title-lg'>
      {loading}
      <Modal.Header closeButton>
        <Modal.Title id='example-modal-sizes-title-lg'>
          Cart Pricing Delete
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!loading && (
          <span>Are you sure you want to remove cart pricing?</span>
        )}
        {loading && <span>Please wait, Cart Pricing is deleting...</span>}
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type='button'
            onClick={onHide}
            className='btn btn-light btn-elevate'>
            Cancel
          </button>
          <> </>
          <button
            type='button'
            onClick={deleteCart}
            className='btn btn-primary btn-elevate'
            disabled={loading ? true : false}>
            Delete
            {loading && (
              <span className='ml-3 spinner px-2 spinner-white'></span>
            )}
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
